import React from 'react';

const CSS = require('./DurationInput.module.scss');

const durationOptions = [
  {
    label: '3 hours',
    value: 3,
  },
  {
    label: '4 hours',
    value: 4,
  },
  {
    label: '5 hours',
    value: 5,
  },
  {
    label: '6 hours',
    value: 6,
  },
  {
    label: '8 hours',
    value: 8,
  },
  {
    label: '1 day',
    value: 24,
  },
  {
    label: '2 days',
    value: 48,
  },
];

function DurationInput({ defaultValue }: { defaultValue: number }) {
  return (
    <div className={CSS.InputContainer}>
      <span className={CSS.Label}>Duration</span>
      <div className={CSS.Input}>
        <select
          defaultValue={defaultValue}
          className={CSS.Select}
          name={'duration'}
        >
          {durationOptions.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default DurationInput;
